import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { PlantList } from 'src/app/Modules/idms/components/plant-manager/models/plant-manager.model';
import { CustomToastService } from 'src/app/services/custom-toast.service';

@Component({
    selector: 'app-image-crop-model',
    templateUrl: './image-crop-model.component.html',
    styleUrls: ['./image-crop-model.component.scss'],
})
export class ImageCropModelComponent implements OnInit {
    @Input() imageChangedEvent: any;
    @Input() ImageArray: any = [];
    @Input() index: number;
    @Input() imgType: string;
    @Input() JointData: PlantList;
    @Input() ratio: number = 1;
    @ViewChild('fileInput') fileInput: any;

    croppedImage: any = '';
    canvasRotation = 0;
    rotation = 0;
    scale = 1;
    showCropper = false;
    containWithinAspectRatio = false;
    transform: ImageTransform = {};
    imageFiles: any = [];
    croppedImageArray: any = [];
    croppedImageArrayCopy: any = [];
    currentIndex = 0;
    lotsOfTabs = new Array(30).fill(0).map((_, index) => `Tab ${index}`);

    constructor(
        private sanitizer: DomSanitizer,
        private ngbActiveModal: NgbActiveModal,
        private cd: ChangeDetectorRef,
        private customToastService: CustomToastService
    ) {}

    async ngOnInit() {
        this.croppedImageArray = [];
        this.imageFiles = this.imageChangedEvent?.target?.files;
        if (this.ImageArray) {
            for (let i = 0; i < this.ImageArray.length; i++) {
                this.ImageArray[i]['CropStyle'] = {
                    scale: 1,
                    rotation: 0,
                    canvasRotation: 0,
                    transform: this.transform,
                };
                this.croppedImageArray.push(this.ImageArray[i]);
            }
        }

        if (this.index >= 0) {
            this.showCropper = false;
            const base64Data = await this.readFileAsDataURL(this.imageChangedEvent.target.files['0']);
            const blob = this.base64ToBlob(base64Data);
            for (let i = 0; i < this.croppedImageArray.length; i++) {
                this.croppedImageArrayCopy.push(this.croppedImageArray[i]);
            }

            this.croppedImageArray[this.index] = {
                file: this.imageChangedEvent.target.files['0'],
                url: URL.createObjectURL(blob),
                CropStyle: {
                    scale: 1,
                    rotation: 0,
                    canvasRotation: 0,
                    transform: this.transform,
                },
            };
            this.currentIndex = this.index;
            this.showCropper = true;
            this.croppedImageArrayCopy = this.croppedImageArray.map((x) => x);
            this.cd.detectChanges();
        } else {
            this.convertingImgBaseUrl();
        }
    }

    LoadTransform() {
        return this.croppedImageArray[this.currentIndex]?.CropStyle?.transform;
    }

    LoadcanvasRotation() {
        return this.croppedImageArray[this.currentIndex]?.CropStyle?.canvasRotation;
    }

    async convertingImgBaseUrl() {
        this.showCropper = false;
        if (this.imageFiles?.length) {
            for (const x of Object.values(this.imageFiles)) {
                const base64Data = await this.readFileAsDataURL(x);
                const blob = this.base64ToBlob(base64Data);
                this.croppedImageArray.push({
                    file: x,
                    url: URL.createObjectURL(blob),
                    CropStyle: {
                        scale: 1,
                        rotation: 0,
                        canvasRotation: 0,
                        transform: this.transform,
                    },
                });
            }
        }
        // this.croppedImageArrayCopy=this.croppedImageArray.splice()
        for (let i = 0; i < this.croppedImageArray.length; i++) {
            this.croppedImageArrayCopy.push(this.croppedImageArray[i]);
        }
        this.currentIndex = this.croppedImageArray.length - 1;
        this.showCropper = true;
        // this.cd.detectChanges();
    }

    croppedImageArrayFn() {
        return this.croppedImageArray[this.currentIndex]?.url;
    }

    readFileAsDataURL(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (event) => {
                resolve(event.target.result);
            };

            reader.onerror = (error) => {
                reject(error);
            };

            reader.readAsDataURL(file);
        });
    }

    base64ToBlob(base64Data): Blob {
        const parts = base64Data.split(';base64,');
        const contentType = parts[0].split(':')[1];
        const byteCharacters = atob(parts[1]);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        return new Blob(byteArrays, { type: contentType });
    }

    imageCropped(event: ImageCroppedEvent) {
        this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl);
        let file = this.convertBlobToFile(
            event.blob,
            this.croppedImageArrayCopy[this.currentIndex].file.name,
            this.croppedImageArrayCopy[this.currentIndex].file.type
        );
        this.croppedImageArrayCopy[this.currentIndex].newurl = this.croppedImage.changingThisBreaksApplicationSecurity;
        this.croppedImageArrayCopy[this.currentIndex].file = file;
        // if (this.croppedImageArrayCopy[this.currentIndex].newurl){
        //     this.croppedImageArrayCopy[this.currentIndex].newurl = this.croppedImage.changingThisBreaksApplicationSecurity;
        // }
        // else this.croppedImageArrayCopy[this.currentIndex].newurl = this.croppedImage.changingThisBreaksApplicationSecurity;
    }

    imageLoaded() {
        if ((!this.index || this.index == null, this.index == undefined)) {
            this.showCropper = true;
        }
    }

    loadImageFailed() {}

    rotateLeft() {
        this.croppedImageArray[this.currentIndex].CropStyle.canvasRotation--;
        this.flipAfterRotate();
    }

    rotateRight() {
        this.croppedImageArray[this.currentIndex].CropStyle.canvasRotation++;
        this.flipAfterRotate();
    }

    private flipAfterRotate() {
        const flippedH = this.croppedImageArray[this.currentIndex].CropStyle.transform.flipH;
        const flippedV = this.croppedImageArray[this.currentIndex].CropStyle.transform.flipV;
        this.croppedImageArray[this.currentIndex].CropStyle.transform = {
            ...this.croppedImageArray[this.currentIndex].CropStyle.transform,
            flipH: flippedV,
            flipV: flippedH,
        };
    }

    flipHorizontal() {
        this.croppedImageArray[this.currentIndex].CropStyle.transform = {
            ...this.croppedImageArray[this.currentIndex].CropStyle.transform,
            flipH: !this.croppedImageArray[this.currentIndex].CropStyle.transform.flipH,
        };
    }

    flipVertical() {
        this.croppedImageArray[this.currentIndex].CropStyle.transform = {
            ...this.croppedImageArray[this.currentIndex].CropStyle.transform,
            flipV: !this.croppedImageArray[this.currentIndex].CropStyle.transform.flipV,
        };
    }

    resetImage() {
        this.scale = 1;
        this.rotation = 0;
        this.canvasRotation = 0;
        this.transform = {};
        this.croppedImageArray[this.currentIndex].CropStyle.transform = this.transform;
        this.croppedImageArrayCopy[this.currentIndex].CropStyle.transform = this.transform;
        this.croppedImageArray[this.currentIndex].CropStyle.canvasRotation = this.canvasRotation;
        this.croppedImageArrayCopy[this.currentIndex].CropStyle.canvasRotation = this.canvasRotation;
        this.croppedImageArray[this.currentIndex].CropStyle.scale = this.scale;
        this.croppedImageArrayCopy[this.currentIndex].CropStyle.scale = this.scale;
        this.croppedImageArray[this.currentIndex].CropStyle.rotation = this.rotation;
        this.croppedImageArrayCopy[this.currentIndex].CropStyle.rotation = this.rotation;
    }

    zoomOut() {
        if (this.croppedImageArray[this.currentIndex].CropStyle.scale > 0.2) {
            this.croppedImageArray[this.currentIndex].CropStyle.scale = this.croppedImageArray[this.currentIndex].CropStyle.scale - 0.1;
            this.croppedImageArray[this.currentIndex].CropStyle.transform = {
                ...this.croppedImageArray[this.currentIndex].CropStyle.transform,
                scale: this.croppedImageArray[this.currentIndex].CropStyle.scale,
            };
        }
    }

    zoomIn() {
        this.croppedImageArray[this.currentIndex].CropStyle.scale += 0.1;
        this.croppedImageArray[this.currentIndex].CropStyle.transform = {
            ...this.croppedImageArray[this.currentIndex].CropStyle.transform,
            scale: this.croppedImageArray[this.currentIndex].CropStyle.scale,
        };
    }

    toggleContainWithinAspectRatio() {
        this.containWithinAspectRatio = !this.containWithinAspectRatio;
    }

    updateRotation() {
        this.croppedImageArray[this.currentIndex].CropStyle.transform = {
            ...this.croppedImageArray[this.currentIndex].CropStyle.transform,
            rotate: this.croppedImageArray[this.currentIndex].CropStyle.rotation,
        };
    }

    nextClick() {
        this.croppedImageArrayCopy = this.croppedImageArrayCopy.map((res) => {
            if (res.newurl) {
                res.url = res.newurl;
            }
            return res;
        });
        this.ngbActiveModal.close(this.croppedImageArrayCopy);
    }

    selectImg(i: number) {
        this.currentIndex = i;
    }

    deleteSelectedImage(i) {
        let croppedImageArray = this.croppedImageArray;
        this.croppedImageArray = [];
        croppedImageArray.forEach((element) => {
            if (croppedImageArray[i] && croppedImageArray[i].url != element.url) {
                this.croppedImageArray.push(element);
            }
        });
        if (i <= this.currentIndex && this.croppedImageArray?.length > 0) {
            this.currentIndex = this.currentIndex - 1;
        }
        if (!this.croppedImageArray?.length) {
            this.currentIndex = null;
        }
        this.croppedImageArrayCopy = this.croppedImageArray;
        this.cd.detectChanges();
    }

    openFile() {
        this.fileInput.nativeElement.click();
    }

    async handleFileSelect(event: any) {
        const selectedFile = event.target.files[0];
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];

        if (!allowedTypes.includes(selectedFile.type)) {
            // File type is not allowed
            this.customToastService.errorToast('Please select a .jpeg, .jpg, .png, or .webp file.', 'Error');
            return;
        }
        const base64Data = await this.readFileAsDataURL(event.target.files[0]);
        const blob = this.base64ToBlob(base64Data);
        this.croppedImageArray.push({
            file: event.target.files[0],
            url: URL.createObjectURL(blob),
            CropStyle: {
                scale: 1,
                rotation: 0,
                canvasRotation: 0,
                transform: this.transform,
            },
        });
        this.croppedImageArrayCopy = this.croppedImageArray;
        this.currentIndex = this.croppedImageArray.length - 1;

        this.cd.detectChanges();
    }

    closeClick() {
        this.ngbActiveModal.close();
    }

    convertBlobToFile(blob: Blob, fileName: string, fileType: string): File {
        return new File([blob], fileName, { type: fileType });
    }
}
